import PageWorkspacePanel from './pageWorkspacePanel.container'

export default PageWorkspacePanel